import {
  GRAY_SCALE_02,
  GRAY_SCALE_10,
  PRIMARY_BLUE_02,
  PRIMARY_BLUE_07,
} from 'bd-web-components/src/utils/dash-colors'
import styled, { css } from 'styled-components'

interface ExceptionContainerProps {
  height: number
  margin: boolean
}

export const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
  margin-top: 20px;
  @media (max-width: 768px) {
    max-width: 100%;
    flex-direction: column;
  }
`

export const DataGridContainer = styled.div`
  @media (max-width: 768px) {
    width: 100%;
  }
  &.user {
    min-height: 200px;
    max-height: 200px;
  }
`

export const ItemTitle = styled.p`
  color: ${GRAY_SCALE_02};
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0%;
  margin-top: 26px;
  margin-bottom: 16px;
  @media (max-width: 768px) {
    font-weight: 600;
    font-size: 14px;
    line-height: 22.4px;
    letter-spacing: 0%;
  }
`

export const ExceptionContainer = styled(styled.div``)<ExceptionContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.height !== undefined &&
    css`
      height: ${props.height}px;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin-bottom: 100px;
    `}
`

export const MessageContainer = styled.div`
  background-color: ${GRAY_SCALE_10};
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 150px;
  padding: 30px 16px 30px 16px;
  text-align: center;
  @media (max-width: 762px) {
    padding: 10px 15px 10px 15px;
    height: 90px;
  }
`

export const MessageInfoBold = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22.4px;
  color: ${PRIMARY_BLUE_02};
  @media (max-width: 762px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`

export const MessageInfo = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.6px;
  color: ${PRIMARY_BLUE_07};
  @media (max-width: 762px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`
